var map = {
	"./backgrounds/background.png": 13,
	"./icons/01.png": 530,
	"./icons/02.png": 772,
	"./icons/03.png": 510,
	"./icons/04.png": 83,
	"./icons/09.png": 877,
	"./icons/10.png": 171,
	"./icons/11.png": 817,
	"./icons/13.png": 769,
	"./icons/50.png": 144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;